<template>
  <admin-outreach
    :entries="entries"
    :loading="loading"
  />
</template>
<script>
import { ranges } from '@/components/Widgets/Reports/DataRangeSelector';
import integrable from '@/components/mixins/integrable';
import { FETCHING } from '@/_store/profile.module';
import AdminOutreach from './AdminOutreach';

export default {
  name: 'AdminOutreachContainer',
  components: {
    AdminOutreach,
  },
  mixins: [integrable],
  props: {
    dataRange: {
      type: String,
      required: true,
    },
  },
  computed: {
    dataRangeIndex() {
      return ranges.indexOf(this.dataRange) - 1; // TODO: Backend is missing TODAY range
    },
    entries() {
      const stats = this.$store.state.profiles.teamStats;
      // According to https://docs.google.com/spreadsheets/d/1EjQMD3hsJ7re5R3-onwWVXqBPuk8hH5z-DjUMJDtG_Q/edit?ts=604ab87a#gid=0
      const labels = [
        { key: 'name', label: 'Sales Associate' },
        { key: 'campaigns', label: 'Edits Created' },
        { key: 'reached', label: '# Clients Reached' },
        { key: 'penetration', label: 'Book Penetration', formatter: this.formatPercent },
        { key: 'sent', label: 'Emails Sent' },
        { key: 'total_opens', label: 'Email Opens' },
        { key: 'total_clicks', label: 'Email Clicks' },
        { key: 'links_created', label: 'Share Links Sent' },
        { key: 'link_opens', label: 'Share Link Opens' },
        { key: 'link_clicks', label: 'Share Link Clicks' },
        { key: 'pdfs_created', label: 'PDFs Shared' },
        { key: 'pdfs_clicks', label: 'PDFs Clicks' },
        { key: 'personal_appointments', label: 'In-person Appointments' },
        { key: 'virtual_appointments', label: 'Virtual Appointments' },
      ];
      /*
      if (this.isIntegrated) {
        labels.push({ key: 'total_revenue', label: 'Total Revenue', formatter: this.formatPrice });
      }
      */
      return {
        labels,
        profiles: stats.map(({
          pk, opens, first_name: firstName, last_name: lastName, activity_stats: activityStats,
        }) => ({
          pk,
          ...activityStats,
          name: `${firstName} ${lastName.length ? lastName[0].toUpperCase() : ''}.`,
        })),
      };
    },
    isAdmin() {
      return this.$store.state.account.isAdminMode;
    },
    loading() {
      return this.$store.state.profiles.status === FETCHING;
    },
  },
  watch: {
    dataRange(newval) {
      this.fetchStats();
    },
  },
  mounted() {
    this.fetchStats();
  },
  methods: {
    fetchStats() {
      this.$store.dispatch('profiles/fetchStats', this.dataRange);
    },
    /** Get value for current data range for stat with given label. * */
    getStatValue(stats, label, formatter = this.formatGeneric) {
      // Find entries for label
      const results = stats.entries.filter((entry) => entry.name.toLowerCase() === label.toLowerCase());
      if (results.length === 0) {
        // No stats for this label. Key is undefined.
        return '--';
      }
      if (results.length > 1) {
        console.warn('More than 1 stat found for label', label);
      }
      return formatter(results[0].values[this.dataRangeIndex]);
    },
    formatPercent(num) {
      return this.isNull(num) ? '--' : `${this.$options.filters.formatFloat(num * 100, 1)}%`;
    },
    isNull(value) {
      // eslint-disable-next-line
      return value === null || value === undefined || isNaN(value)
    },
    formatFloat(value) {
      return this.$options.filters.formatFloat(value, 1);
    },
    formatPrice(value) {
      return this.isNull(value) ? '--' : this.$options.filters.formatPrice(value);
    },
  },
};
</script>
<style lang="css"
  scoped>
</style>
